import axios from 'axios';

const envUrl = process.env.REACT_APP_API_URL || '';
const API_URL = envUrl.replace(/\/api\/?$/, '');

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para añadir el token a todas las peticiones
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Dejar que axios maneje el Content-Type para FormData (multipart/form-data con boundary)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      // No redirigir al login si es una verificación de contraseña de la bóveda
      if (url.includes('verify-password')) {
        // Solo rechazar el error, no redirigir
        return Promise.reject(error);
      }
      // Tampoco durante una grabación de minuta: navegar a /login en pleno
      // upload de chunks destruiría la grabación en curso
      if (/\/api\/minutas\/\d+\/(chunk|finalizar)/.test(url)) {
        return Promise.reject(error);
      }
      // Limpiar token y recargar la página para forzar el redireccionamiento al login
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; 